/*
 * @Description: 接口配置
 * @Version: 1.0
 * @Autor: zhaohc
 * @Date: 2021-07-12 10:35:59
 * @LastEditors: niuzijie
 * @LastEditTime: 2025-05-27 11:42:13
 */
import { post, get } from '@/@public/http/request'
import { postDY } from '@/http/request'
import { postH5 } from '@/http/requestOrderH5'

// 优惠卷-获取微信配置
export const getAppletParams = {
  getAppletParams(env) {
    return post(`/applets/portal/getWxConfig?url=${env}`)
  },
}

// 获取小程序URL Scheme
export const getScheme = {
  getSchemeUrl(url, path = '') {
    return post(`/applets/qrCode/getSchemeUrl?queryParams=webUrl=${url}&path=${path}`)
  },
  getSchemeUrl2(params) {
    return post(`/applets/qrCode/getSchemeUrl?queryParams=${params.queryParams}&path=${params.path}&version=${params.version || ''}`)
  },
}

export const receiveBenefit = {
  addReceiveBenefit(params) {
    return post(`/applets/api/receiveBenefit/addReceiveBenefit`, params)
  },
  getAddressListFilter(params) { // 获取省市区数据
    return get(`/applets/baseData/findDistrict/filter`, params)
  },
  getAddressList(params) { // 获取省市区数据
    return get(`/applets/baseData/findDistrict`, params)
  },
  getCaptcha(params) { // 获取图片验证码
    return post(`/applets/user/captcha`, params)
  },
  getImgList(params) { // 获取活动页图片
    return post('/applets/activity/promotion/list', params)
  },
  christmasRegistrationActivity(params) { // 获取活动页图片
    return post('/applets/api/receiveBenefit/christmasRegistrationActivity', params)
  },
}

export const coupon = {
  getCoupon: params => postDY('/dyapplets/dx/login', params),
  getSchemeUrl: path => post(`/applets/qrCode/getSchemeUrl?queryParams=&path=${path}`),
}

export const pullNew = {
  newCustomerActivitySp: (params) => post(`/applets/newCustomerActivitySp/signUp`, params),
  refreshPageViews: (params) => get(`/applets/marketActivity/refreshPageViews`, params),
}

// 获取运单详情
export const getWaybillApi = {
  getWaybillDetailAndUser: (params) => postH5(`/order/pod/tracking/v2/getDetailByWaybillNo`, params),
}
